/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_SubtitleInputs */

const zh_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无论你是个人学习者还是教育机构，我们都有适合你的方案。`)
};

const en_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whether you're an individual learner or an educational institution, we have a plan that fits your needs.`)
};

const es_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya seas un estudiante individual o una institución educativa, tenemos un plan que se adapta a tus necesidades.`)
};

/**
* | output |
* | --- |
* | "Whether you're an individual learner or an educational institution, we have a plan that fits your needs." |
*
* @param {Pricing_SubtitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_subtitle = /** @type {((inputs?: Pricing_SubtitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_SubtitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_subtitle(inputs)
	if (locale === "en") return en_pricing_subtitle(inputs)
	return es_pricing_subtitle(inputs)
});